import { render, staticRenderFns } from "./mediaType.vue?vue&type=template&id=24e605ae"
import script from "./mediaType.vue?vue&type=script&lang=js"
export * from "./mediaType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e605ae')) {
      api.createRecord('24e605ae', component.options)
    } else {
      api.reload('24e605ae', component.options)
    }
    module.hot.accept("./mediaType.vue?vue&type=template&id=24e605ae", function () {
      api.rerender('24e605ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/mediaType.vue"
export default component.exports